import { Box } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import {
  BorrowingBaseSummaryInput,
  BorrowingBaseSummarySections,
  LinkAddressAndLabel,
} from './utils';

export const BorrowingBaseSummaryWithAllValuesAndDifference: React.FC<{
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReports: BorrowingBaseSummaryInput;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  eligibilityLink?: LinkAddressAndLabel;
  concentrationLink?: LinkAddressAndLabel;
}> = ({
  sections,
  borrowingBaseReports,
  creditAgreement,
  eligibilityLink,
  concentrationLink,
}) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = true;

  return (
    <Box mb="24px">
      {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
        <BorrowingBaseSummaryFacilitySummary
          borrowingBaseReports={{
            minuendBorrowingBaseReport:
              borrowingBaseReports.minuendBorrowingBaseReport,
            subtrahendBorrowingBaseReport:
              borrowingBaseReports.subtrahendBorrowingBaseReport,
            referenceBorrowingBaseReport:
              borrowingBaseReports.referenceBorrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(BorrowingBaseSummarySections.receivables) && (
        <BorrowingBaseSummaryReceivables
          borrowingBaseReports={{
            minuendBorrowingBaseReport:
              borrowingBaseReports.minuendBorrowingBaseReport,
            subtrahendBorrowingBaseReport:
              borrowingBaseReports.subtrahendBorrowingBaseReport,
            referenceBorrowingBaseReport:
              borrowingBaseReports.referenceBorrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
          eligibilityLink={eligibilityLink}
          concentrationLink={concentrationLink}
        />
      )}
      {includesSection(BorrowingBaseSummarySections.cash) && (
        <BorrowingBaseSummaryCash
          borrowingBaseReports={{
            minuendBorrowingBaseReport:
              borrowingBaseReports.minuendBorrowingBaseReport,
            subtrahendBorrowingBaseReport:
              borrowingBaseReports.subtrahendBorrowingBaseReport,
            referenceBorrowingBaseReport:
              borrowingBaseReports.referenceBorrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(
        BorrowingBaseSummarySections.finalBorrowingBaseReport,
      ) && (
        <BorrowingBaseSummaryFinalBorrowingBaseReport
          borrowingBaseReports={{
            minuendBorrowingBaseReport:
              borrowingBaseReports.minuendBorrowingBaseReport,
            subtrahendBorrowingBaseReport:
              borrowingBaseReports.subtrahendBorrowingBaseReport,
            referenceBorrowingBaseReport:
              borrowingBaseReports.referenceBorrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
    </Box>
  );
};
